export const NAMESPACE = 'myloungeMetadata';
